import { Pipe, PipeTransform } from '@angular/core';
const math = require('mathjs')

@Pipe({
    name: 'iconoCielo',
    standalone: true
})
export class IconoCieloPipe implements PipeTransform {

  transform(fullArray): string {
    if (!fullArray) {
      return '';
    }
    let masFrecuente = math.mode(fullArray)
    if (masFrecuente[0] == '11') {
      return './assets/imagenes/Meteo/Sol.png'
    } else if (masFrecuente[0] == '11n') {
      return './assets/imagenes/Meteo/Noche.png'
    } else if (masFrecuente[0] == '12' || masFrecuente[0] == '13' || masFrecuente[0] == '14' || masFrecuente[0] == '17') {
      return './assets/imagenes/Meteo/SolNube.png'
    } else if (masFrecuente[0] == '12n' || masFrecuente[0] == '13n' || masFrecuente[0] == '14n' || masFrecuente[0] == '17n') {
      return './assets/imagenes/Meteo/NocheNube.png'
    } else if (masFrecuente[0] == '15' || masFrecuente[0] == '15n' || masFrecuente[0] == '16' || masFrecuente[0] == '16n') {
      return './assets/imagenes/Meteo/Cubierto.png'
    } else if (masFrecuente[0] == '43' || masFrecuente[0] == '44' || masFrecuente[0] == '23' || masFrecuente[0] == '24') {
      return './assets/imagenes/Meteo/SolLluvia.png'
    } else if (masFrecuente[0] == '43n' || masFrecuente[0] == '44n' || masFrecuente[0] == '23n' || masFrecuente[0] == '24n') {
      return './assets/imagenes/Meteo/NocheLluvia.png'
    } else if (masFrecuente[0] == '45' || masFrecuente[0] == '45n' || masFrecuente[0] == '46' || masFrecuente[0] == '46n' || masFrecuente[0] == '25' || masFrecuente[0] == '25n' || masFrecuente[0] == '26' || masFrecuente[0] == '26n') {
      return './assets/imagenes/Meteo/CubiertoLluvia.png'
    } else if (masFrecuente[0] == '71' || masFrecuente[0] == '71n' || masFrecuente[0] == '72' || masFrecuente[0] == '72n' || masFrecuente[0] == '73' || masFrecuente[0] == '73n' || masFrecuente[0] == '74' || masFrecuente[0] == '74n' || masFrecuente[0] == '33' || masFrecuente[0] == '33n' || masFrecuente[0] == '34' || masFrecuente[0] == '34n' || masFrecuente[0] == '35' || masFrecuente[0] == '35n' || masFrecuente[0] == '36' || masFrecuente[0] == '36n') {
      return './assets/imagenes/Meteo/Nieve.png'
    } else if (masFrecuente[0] == '51' || masFrecuente[0] == '51n' || masFrecuente[0] == '52' || masFrecuente[0] == '52n' || masFrecuente[0] == '53' || masFrecuente[0] == '53n' || masFrecuente[0] == '54' || masFrecuente[0] == '54n' || masFrecuente[0] == '61' || masFrecuente[0] == '61n' || masFrecuente[0] == '62' || masFrecuente[0] == '62n' || masFrecuente[0] == '63' || masFrecuente[0] == '63n' || masFrecuente[0] == '64' || masFrecuente[0] == '64n') {
      return './assets/imagenes/Meteo/Tormenta.png'
    } else if (masFrecuente[0] == '81' || masFrecuente[0] == '82' || masFrecuente[0] == '82n' || masFrecuente[0] == '83') {
      return './assets/imagenes/Meteo/Niebla.png'
    }


  }
}
